export default __webpack_public_path__ + "static/media/logo-dark.07aa80a9.svg";